import { useCallback, useContext } from "react";

import { ViewStateContext } from "@is/contexts";
import { Device } from "@is/types";

const useManageSelectDevice = () => {
  const { activeStepIndex, device, steps, updateViewState } =
    useContext(ViewStateContext).registration;

  const handleSelectDeviceType = useCallback(
    (device: Device) => {
      const newSteps = [...steps];
      const nextStepIndex = activeStepIndex + 1;

      newSteps[activeStepIndex] = {
        ...newSteps[activeStepIndex],
        label: device.name,
      };

      if (newSteps[nextStepIndex].label) {
        newSteps[nextStepIndex] = {
          ...newSteps[nextStepIndex],
          label: "",
        };
      }

      updateViewState({
        device,
        steps: newSteps,
        activeStepIndex: nextStepIndex,
        deviceName: device.name,
      });
    },
    [activeStepIndex, steps, updateViewState]
  );

  return {
    selectedDevice: device,
    handleSelectDeviceType,
  };
};

export default useManageSelectDevice;
